import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { useProfileData } from "../../../hooks/useProfileData";
import { getEntityStatistics } from "../../services/entities";
import { Insight } from "../../../types";

type UseQueryHotInsightsQueryResult = {
  insightsList: Insight[] | undefined;
  isInsightDataLoading: boolean;
  isInsightDataHasError: boolean;
};

export const useQueryHotInsights = (): UseQueryHotInsightsQueryResult => {
  const { i18n } = useTranslation();
  const { data: userData } = useProfileData();
  const entityId = userData?.entityId;

  const {
    data: insightsList,
    isLoading: isInsightDataLoading,
    isError: isInsightDataHasError,
  } = useQuery<Insight[]>({
    queryKey: ["Dashboard", "HotInsights", i18n.language, entityId],
    queryFn: async () => await getEntityStatistics(entityId),
    enabled: !!entityId,
  });

  return { insightsList, isInsightDataLoading, isInsightDataHasError };
};
